import { useEffect, useState } from "react";

const useImagePdf = (imageUrl: string | undefined) => {
  const [finalImageUrl, setFinalImageUrl] = useState<string>();

  useEffect(() => {
    imageUrl &&
      fetch(imageUrl).then(
        (a) => a.status === 200 && setFinalImageUrl(imageUrl),
      );
  }, [imageUrl]);

  return finalImageUrl;
};

export default useImagePdf;
